import bybitIcon from '~img/exchanges/bybit.png'
import gateioIcon from '~img/exchanges/gateio.png'
import kucoinIcon from '~img/exchanges/kucoin.png'
import pcsIcon from '~img/exchanges/pcs.png'
import thenaIcon from '~img/exchanges/thena.png'
import uniswapIcon from '~img/exchanges/uniswap.png'
import dXcad from '~img/exchanges/dxcad.png'

export const centralizedExchanges = [
  {
    icon: kucoinIcon,
    name: 'Kucoin',
    featured: false,
    url: 'https://www.kucoin.com/es/trade/XCAD-USDT',
  },
  {
    icon: bybitIcon,
    name: 'ByBit',
    featured: false,
    url: 'https://www.bybit.com/en/trade/spot/XCAD/USDT',
  },
  {
    icon: gateioIcon,
    name: 'GateIO',
    featured: false,
    url: 'https://www.gate.io/es/trade/XCAD_USDT',
  },
]

export const decentralizedExchanges = [
  {
    icon: thenaIcon,
    name: 'Thena',
    featured: false,
    url: 'https://thena.fi/swap?inputCurrency=BNB&outputCurrency=0xf4c8e32eadec4bfe97e0f595add0f4450a863a11&swapType=1',
  },
  {
    icon: pcsIcon,
    name: 'PancakeSwap',
    featured: false,
    url: 'https://pancakeswap.finance/swap?inputCurrency=0xa026Ad2ceDa16Ca5FC28fd3C72f99e2C332c8a26&chain=bsc',
  },
  {
    icon: uniswapIcon,
    name: 'Uniswap',
    featured: false,
    url: 'https://app.uniswap.org/swap',
  },
  {
    icon: dXcad,
    name: 'dXCAD',
    featured: false,
    url: 'https://dxcadswap.com/swap',
  },
]
